<div class="padding flex column">
	<h4 class="bold margin-bottom-small">Add shot</h4>

	<div class="flex">
		<div class="flex column flex-1">
			<b>Shot type</b>

			<mat-select [(value)]="shot.shotType" class="margin-top-smallest margin-bottom fix-width" placeholder="Select a shot type">
				@for (type of shotTypes; track type) {
					<mat-option [value]="type">{{ type.code }} - {{ type.name }}</mat-option>
				}
			</mat-select>

			<b>Media format</b>
			<mat-select [(value)]="shot.mediaFormat" class="margin-top-smallest margin-bottom fix-width" placeholder="Select a media format">
				@for (format of mediaFormats; track format) {
					<mat-option [value]="format">{{ format.code }}</mat-option>
				}
			</mat-select>

			<b>Codified use</b>
			<mat-select [(value)]="shot.codifiedUse" class="margin-top-smallest fix-width" placeholder="Select a codified use">
				@for (use of codifiedUses; track use) {
					<mat-option [value]="use">{{ use.code }} - {{ use.name }}</mat-option>
				}
			</mat-select>
		</div>

		<div class="flex column flex-1 margin-left-large">
			<b>Aspect ratio</b>

			<div class="margin-top-smallest flex column fix-width">
				@for (aspect of aspectRatios; track aspect) {
					<div class="flex center {{ aspect.selected ? 'border bg-lightest-blue' : '' }} padding-small hover " (click)="selectAspectRatio(aspect)">
						<div class="flex-0 margin-right-small">
							<div class="placeholder" [style.background-image]="'url(null)'">
								<div class="image i-{{ aspect.label }} bg-primary"></div>
							</div>
						</div>

						<div class="flex-1 flex column">
							<b>{{ aspect.label }}</b>
							<span class="grey">{{ aspect.orientation }}</span>
						</div>
					</div>
				}
			</div>
		</div>
	</div>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			<button (click)="apply()" [disabled]="!validateShot()">
				<i class="fa-solid fa-check"></i>

				Apply
			</button>
		</div>
	</div>
</div>
